'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  color: ', ';\n  font-size: 14px;\n  font-weight: ', ';\n  text-align: center;\n  text-decoration: ', ';\n  font-family: \'Nunito Sans\';\n  cursor: pointer;\n'], ['\n  ', '\n  color: ', ';\n  font-size: 14px;\n  font-weight: ', ';\n  text-align: center;\n  text-decoration: ', ';\n  font-family: \'Nunito Sans\';\n  cursor: pointer;\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var colorMap = {
  primary: '#6E0AD6',
  secondary: '#4a4a4a',
  white: '#fff'
};
var LINK = function LINK(props) {
  // removing props from DOM
  var underline = props.underline,
    type = props.type,
    fontWeight = props.fontWeight,
    children = props.children,
    nativeRef = props.nativeRef,
    otherProps = (0, _objectWithoutProperties3.default)(props, ['underline', 'type', 'fontWeight', 'children', 'nativeRef']); // eslint-disable-line

  return _react2.default.createElement('a', otherProps, children);
};
var link = (0, _styledComponents2.default)(LINK)(_templateObject, function (props) {
  return props.fontAdjust;
}, function (props) {
  return colorMap[props.type];
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.underline ? 'underline' : 'none';
});
link.propTypes = {
  type: _propTypes2.default.oneOf(['primary', 'secondary', 'white']),
  fontWeight: _propTypes2.default.number,
  underline: _propTypes2.default.bool,
  href: _propTypes2.default.string,
  track: _propTypes2.default.string,
  fontAdjust: _propTypes2.default.string,
  target: _propTypes2.default.string
};
link.defaultProps = {
  href: '#',
  type: 'secondary',
  fontWeight: 500,
  underline: true
};
exports.default = link;